import { useState, useEffect } from "react";
import { connect } from "react-redux";
import Table from "./Table";
import { Document, Page, pdfjs } from "react-pdf";
import reultsService from "../../../Services/resultsService";
import "react-pdf/dist/esm/Page/TextLayer.css";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import { useWindowWidth, useWindowHeight } from "@wojtekmaj/react-hooks";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

function Invoices(props) {
  const [pageNumber, setPageNumber] = useState(1);
  const onLoadSuccess = ({ numPages }) => {
    if (numPages) {
      setPageNumber(numPages);
    } else {
      setPageNumber(1);
    }
  };
  const width = useWindowWidth();
  const height = useWindowHeight();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 900px)" });
  const [currentPage, setCurrentPage] = useState(1);
  const [invoiceSelected, setInvoiceSelected] = useState();
  const [pdfString, setPdfString] = useState();
  const resultList = props.invoices;
  useEffect(() => {
    if (invoiceSelected) {
      reultsService
        .getInvoiceFile(invoiceSelected.docNum, invoiceSelected.docType)
        .then((p) => setPdfString(p.data));
    } else {
      if (resultList) {
        setInvoiceSelected(resultList[0]);
      }
    }
  }, [invoiceSelected]);

  const pages = Math.ceil(resultList?.length / 10);
  const toShow = resultList?.slice(
    (currentPage - 1) * 10,
    (currentPage - 1) * 10 + 10
  );
  const selectInvoiceByDoc = (d) => {
    const selected = resultList?.find((e) => e.docNum == d.docNum);
    setInvoiceSelected(selected);
  };
  const selectInvoiceByDocNum = (d) => {
    const selected = resultList?.find((e) => e.docNum == d);
    setInvoiceSelected(selected);
  };

  const downloadPDF = () => {
    const linkSource = `data:application/pdf;base64,${pdfString}`;
    const downloadLink = document.createElement("a");

    downloadLink.href = linkSource;
    downloadLink.download = `shl_invoice_${moment(
      invoiceSelected?.docNum
    ).format("DD_MM_YYYY_HH_mm")}.PDF`;
    downloadLink.click();
  };

  return (
    <div>
      <h2>חשבוניות</h2>
      <div
        className="chartTemplate"
        style={{ display: resultList?.length == 0 && "none" }}
      >
        <div style={{ marginTop: 10 }}>
          <h3 style={{ display: resultList?.length > 0 && "none" }}>
            אין נתונים
          </h3>
          {!isTabletOrMobile && (
            <Table
              kind="invoices"
              selectRow={(e) => selectInvoiceByDoc(e)}
              updateSelectRow={invoiceSelected}
              measurment={toShow}
              pages={pages}
              currentPage={currentPage}
              updatePageNumber={(i) => setCurrentPage(i)}
            />
          )}
        </div>
        <div>
          {isTabletOrMobile && (
            <div>
              <p>בחירת חשבונית:</p>

              <p>
                <select
                  onChange={(e) => selectInvoiceByDocNum(e.target.value)}
                  value={invoiceSelected?.docNum}
                  className="selectEcg"
                >
                  {resultList?.map((e) => {
                    return (
                      <option key={e.docNum} value={e.docNum}>
                        {e.title}- (
                        {moment(new Date(e.devdatetime)).format("MM/YY")})
                      </option>
                    );
                  })}
                </select>
              </p>
            </div>
          )}
          <h4 style={{ margin: -20 }}>
            {invoiceSelected?.title}
            <br />
            <p className="downloadFile" onClick={() => downloadPDF()}>
              להורדת הקובץ
            </p>
          </h4>
          <div className="shaddow">
            <Document
              file={`data:application/pdf;base64,${pdfString}`}
              onLoadSuccess={({ numPages }) => setPageNumber(numPages)}
            >
              {Array.apply(null, Array(pageNumber))
                .map((x, i) => i + 1)
                .map((page) => (
                  <Page
                    key={page}
                    pageNumber={page}
                    renderTextLayer={false}
                    width={
                      isTabletOrMobile
                        ? Math.min(900, width * 0.6)
                        : Math.min(1700, width * 0.5)
                    }
                  />
                ))}
            </Document>
          </div>{" "}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    invoices: state.invoices,
  };
};
export default connect(mapStateToProps)(Invoices);
